"use client";

import { useMemo, useRef } from "react";

import type { CheckoutProviderProps } from "./Checkout.context";
import { CheckoutContext } from "./Checkout.context";

export function CheckoutProvider(props: CheckoutProviderProps) {
  const {
    children,
    madeToOrderBlock,
    eurobonusBlock,
    details,
    initialCheckout,
  } = props;

  const deliveryStepRef = useRef<HTMLFormElement | null>(null);
  const paymentStepRef = useRef<HTMLDivElement | null>(null);
  const adyenDropInRef = useRef<HTMLDivElement | null>(null);
  const walleyWidgetRef = useRef<HTMLDivElement | null>(null);

  const value = useMemo(
    () => ({
      details,
      initialCheckout,
      madeToOrderBlock,
      eurobonusBlock,
      adyenDropInRef,
      walleyWidgetRef,
      deliveryStepRef,
      paymentStepRef,
    }),
    [details, initialCheckout, madeToOrderBlock, eurobonusBlock],
  );

  return (
    <CheckoutContext.Provider value={value}>
      {children}
    </CheckoutContext.Provider>
  );
}
